module.exports = __webpack_public_path__ + "img/paypal-icon.5aa93075.svg";